/**
 *
 * Asynchronously loads the component for Flow
 *
 */

import React from 'react';
import Loading from '../../components/Loading';
import createLazyComponent from '../../utils/createLazyComponent';

export default createLazyComponent({
  loader: () => import('./index'),
  fallback: (
    <div className="center-absolute">
      <Loading />
    </div>
  ),
});
